import $ from "jquery";
import { EldmlTransform } from "./EldmlTransform";
import { GroupId } from "./EldmlTransformerHelper";

const DEFAULT_AVATAR_SIZE = 40;
const DEFAULT_WITH_TEXT_WIDTH = 240;
const MAX_AVATAR_RENDER_SIZE = 200;
const WITH_TEXT_EXTRA_HEIGHT = 13;
const MAX_WITH_TEXT_HEIGHT = 213;
const CONTEXT_LABELS_PADDING_OFFSET = 10;
const CONTEXT_LABELS_PADDING_MOBILE_OFFSET = 6;

interface AvatarFieldValue {
  groupId: string;
  parentGroupId?: string;
}

export class AvatarTransform extends EldmlTransform {
  apply() {
    const usersToFetch: GroupId[] = [];

    // najpierw przetwarzamy avatary z field value
    this.selector
      .find("avatar[field-value]")
      .each((_: any, element: Element) => {
        const avatar = $(element);

        // wartość
        const value = avatar.attr("field-value");

        // czy ma być z tekstem
        const withTextIfOneEntry = avatar.attr("with-text-if-one-entry");
        const withText = avatar.attr("with-text");

        // deserializujemy
        let jsonObject: [AvatarFieldValue] = value
          ? JSON.parse(value)
          : undefined;

        // kontener
        const container = $("<div class='avatars-container'><div>");

        // czy dzieci z tekstem
        const childrenWithText =
          withText == "true" ||
          (withTextIfOneEntry === "true" && jsonObject.length === 1);

        // tworzymy elementy dzieci
        for (const avatarFieldValue of jsonObject) {
          const innerAvatar = $("<avatar><avatar>");
          innerAvatar.attr("group-id", avatarFieldValue.groupId);
          innerAvatar.attr("context", avatarFieldValue.parentGroupId ?? "");
          innerAvatar.attr("with-text", childrenWithText ? "true" : "false");

          if (childrenWithText && jsonObject.length === 1) {
            innerAvatar.attr("no-limit-width", "true");
          }

          container.append(innerAvatar);
        }

        // zamieniamy
        avatar.replaceWith(container);
      });

    this.selector.find("avatar").each((_: any, element: Element) => {
      const avatar = $(element);
      const groupId = parseInt(avatar.attr("group-id")?.replace(/\s+/g, "") ?? "");
      const context = parseInt(avatar.attr("context")?.replace(/\s+/g, "") ?? "");

      if (groupId && !isNaN(groupId)) {
        usersToFetch.push({
          groupId: groupId,
          context: context && !isNaN(context) ? context : undefined,
        });

        const userDiv = $('<div class="eldml-user"></div>');
        if (context && !isNaN(context)) {
          userDiv.attr("group-id", `${groupId}_${context}`);
        } else {
          userDiv.attr("group-id", groupId);
        }

        const sizeAttr = parseInt(avatar.attr("size") ?? "");
        const popoverSizeAttr = parseInt(avatar.attr("popover-size") ?? "");
        const setPopoverSize = !isNaN(popoverSizeAttr);
        const widthAttr = parseInt(avatar.attr("width") ?? "");
        const withText = avatar.attr("with-text") === "true";
        const popoverWithText = avatar.attr("popover-with-text") !== "false";
        const noLimitWidth = avatar.attr("no-limit-width") === "true";

        const size = isNaN(sizeAttr) ? DEFAULT_AVATAR_SIZE : sizeAttr;

        const avatarDiv = $('<div class="eldml-avatar avatar"><img/></div>');
        userDiv.append(avatarDiv);

        if (setPopoverSize) {
          avatarDiv.find("img").attr("data-psize", popoverSizeAttr);
        }

        userDiv.css({
          maxHeight: "unset",
          maxWidth: "unset",
        });

        if (popoverWithText) {
          userDiv.addClass("popover-with-text");
        }

        if (withText) {
          const contextLabels = $('<div class="context-labels"></div>');
          const nameLabel = $('<label class="name-label"></label>');
          const contextLabel = $(
            '<label class="context-label"><small></small></label>',
          );

          contextLabels.append(nameLabel).append(contextLabel);
          userDiv.append(contextLabels);

          const width = isNaN(widthAttr) ? DEFAULT_WITH_TEXT_WIDTH : widthAttr;

          userDiv.css({
            height:
              size <= MAX_AVATAR_RENDER_SIZE
                ? size + WITH_TEXT_EXTRA_HEIGHT
                : MAX_WITH_TEXT_HEIGHT,
            width: noLimitWidth ? "unset" : width + DEFAULT_AVATAR_SIZE,
          });

          userDiv.addClass("with-text");
        } else {
          const width = isNaN(widthAttr) ? "unset" : widthAttr;

          userDiv.css({
            height: "unset",
            width: width,
            textAlign: "center",
          });

          userDiv.find(".avatar").css({
            float: "none",
            display: "inline-block",
          });
        }

        userDiv.find(".avatar").css({ width: "unset" });

        userDiv.find(".avatar img").css({
          height:
            size <= MAX_AVATAR_RENDER_SIZE ? size : MAX_AVATAR_RENDER_SIZE,
          width: size <= MAX_AVATAR_RENDER_SIZE ? size : MAX_AVATAR_RENDER_SIZE,
          maxWidth: "unset",
          maxHeight: "unset",
        });

        const contextPaddingOffset = this.transformer.mobile
          ? CONTEXT_LABELS_PADDING_MOBILE_OFFSET
          : CONTEXT_LABELS_PADDING_OFFSET;

        userDiv.find(".context-labels").css({
          paddingLeft:
            size <= MAX_AVATAR_RENDER_SIZE
              ? size + contextPaddingOffset
              : MAX_AVATAR_RENDER_SIZE + contextPaddingOffset,
        });

        userDiv.off("click.avatar").on("click.avatar", "img", (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.transformer.onAvatarClick(e.currentTarget, groupId, context, popoverWithText, setPopoverSize ? popoverSizeAttr : undefined);
        });

        avatar.replaceWith(userDiv);
      }
    });

    if (usersToFetch.length > 0) {
      this.transformer.fetchUsers(usersToFetch).then((users) => {
        $.each(users, (_, group) => {
          let id = group.parentId
            ? `${group.groupId}_${group.parentId}`
            : `${group.groupId}`;

          const name = group.parentId
            ? `${group.name} (${group.login})`
            : group.name;
          const context = group.parentId ? group.parentName : group.login;

          this.selector
            .find(`.eldml-user[group-id="${id}"]:not(.proccessed)`)
            .each((j, elem) => {
              const userDiv = $(elem);

              userDiv
                .find(".avatar")
                .attr("data-userid", group.groupId)
                .attr("title", name);

              const avatarWidth =
                userDiv.find(".avatar img").width() ?? DEFAULT_AVATAR_SIZE;

              const defaultAvatarData =
                avatarWidth > DEFAULT_AVATAR_SIZE && group.avatarBig
                  ? group.avatarBig
                  : group.avatar;

              userDiv
                .find(".avatar img")
                .attr("data-image", defaultAvatarData)
                .attr("data-image-big", group.avatarBig)
                .attr("title", name)
                .attr("data-bs-toggle", "popover")
                .attr("data-content-desc", name)
                .attr("data-bs-trigger", "hover")
                .attr("src", this.transformer.getAvatarSrc(defaultAvatarData));

              if (group.login) {
                userDiv.find(".avatar").attr("data-userlogin", group.login);
              }

              userDiv.find(".name-label").text(name).attr("title", name);

              if (context) {
                userDiv
                  .find(".context-label small")
                  .text(context)
                  .attr("title", context);
              }
            });
        });
      });
    }
  }
}
